import { createContext } from 'react';
import { createFetchContextProps } from '../contextFetch/FetchContext';
/**
 * this function generates a user accounts context
 * @return {React.Context} - the active account / recent accounts context context
 */

var initialContext = {
  activeAccount: null,
  recentAccounts: []
};
export function createUserActiveAccountContext() {
  return /*#__PURE__*/createContext(initialContext);
}
/**
 * this function generates a user accounts context
 * @return {React.Context} - the user accounts context
 */

export function createUserAccountsContext() {
  return /*#__PURE__*/createContext(createFetchContextProps());
}
/**
 * this function generates a user data context
 * @return {React.Context} - the user details context
 */

export function createUserDetailsContext() {
  return /*#__PURE__*/createContext(createFetchContextProps());
}
export var ActiveAccountContext = createUserActiveAccountContext();
export var UserAccountsContext = createUserAccountsContext();
export var UserDetailsContext = createUserDetailsContext();